import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../configuration/configuration.service';

/**
 * Loads i18n from V2 or V3 based on ConfigurationService release version at request time.
 * Defaults to V2 unless release version is explicitly 3.0 (v1.x does not use i18n).
 */
@Injectable()
export class VersionedTranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private configurationService: ConfigurationService
  ) {}

  getTranslation(lang: string): Observable<Record<string, unknown>> {
    const version = this.configurationService.getReleaseVersion();
    const prefix = version === '3.0' ? './assets/i18n/V3/' : './assets/i18n/V2/';
    return this.http.get<Record<string, unknown>>(`${prefix}${lang}.json`);
  }
}

export function versionedTranslateLoaderFactory(
  http: HttpClient,
  configurationService: ConfigurationService
): VersionedTranslateHttpLoader {
  return new VersionedTranslateHttpLoader(http, configurationService);
}
